import {getAlternativeRelatedItemsModelLabel} from '../alternativeRelatedItemsModelTest';

export const CLICK_EVENT = 'module click';
export const DISPLAY_EVENT = 'module display';
export const LOADED_EVENT = 'module loaded';

export const CLICK_SECTION = 'pdp related items tabbed view';

export const EVENT_TYPE = {
  ITEM_CLICKED: 'ITEM_CLICKED',
  LOADED: 'LOADED',
  TAB_CHANGED: 'TAB_CHANGED',
  VIEWED: 'VIEWED'
};

export const prepareTabbedViewEventData = ({
  activeTab,
  availableTabs = [],
  eventType = EVENT_TYPE.VIEWED,
  firstTabChange = false,
  previousTab = null,
  styleId = null
}) => {
  const modelLabel = getAlternativeRelatedItemsModelLabel();
  const sharedData = {
    click_section: 'pdp related items tabbed view',
    event: 'pdp_interaction',
    interaction_label: modelLabel
  };

  switch (eventType) {
    case EVENT_TYPE.ITEM_CLICKED:
      return {
        ...sharedData,
        active_tab: activeTab,
        click_link: 'recommendation item',
        interaction_action: CLICK_EVENT,
        product_style_id: styleId
      };
    case EVENT_TYPE.LOADED:
      return {
        ...sharedData,
        available_tabs: availableTabs.map((tab) => tab.toLowerCase()),
        click_link: activeTab,
        interaction_action: LOADED_EVENT
      };
    case EVENT_TYPE.TAB_CHANGED:
      return {
        ...sharedData,
        active_tab: activeTab,
        click_link: 'tab change',
        first_tab_click: firstTabChange,
        interaction_action: 'tab change',
        previous_tab: previousTab
      };
    case EVENT_TYPE.VIEWED:
    default:
      return {
        ...sharedData,
        interaction_action: DISPLAY_EVENT
      };
  }
};

export const fireTabbedViewEvent = (eventData) => {
  window.dataLayer.push(prepareTabbedViewEventData(eventData));
};

export const fireTabbedViewEventWithCallback = ({callback, eventData}) => {
  const data = prepareTabbedViewEventData(eventData);
  window.dataLayer.push({
    ...data,
    eventCallback: callback,
    eventTimeout: 1500
  });
};
